import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";
import qs from "querystringify";

// STATE AND STORE
// LIBS
import API from "../../api";
import Model from "../../models/blanks";
import validateForm from "../../lib/helpers/validateForm";
import {
  fioLitleTruncateFromObject,
  sumFormat
} from "../../lib/helpers/strings";
import { getDateFormat } from "../../lib/helpers/dates";
import { getStatusBlankString, getTypeBlank } from "../../lib/helpers/blanks";
import { getQueryParams } from "../../lib/helpers/blanks";

// UI
import {
  HeaderPage,
  Table,
  Pagination,
  Input,
  Button,
  Row,
  Col,
  VirtualDiv
} from "../../ui";
import IconArrowUpLongBold from "../../ui/src/ui/components/icons/arrowUpLongBold";
import IconArrowDownLongBold from "../../ui/src/ui/components/icons/arrowDownLognBold";

class BlanksListPage extends Component {
  state = {
    titleHeader: "Кассовые ордера",
    loading: true,
    blanks: {
      list: [],
      meta: {
        page: 0,
        pages: 0,
        count: 0,
        perPage: 0,
        fromRecord: 0,
        toRecord: 0
      }
    },
    search: false,
    query: {
      page: 0
    },
    form: {
      number: {
        value: "",
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.number
      }
    },
    buttons: {
      filterDisabled: true
    }
  };

  async componentDidMount() {
    const { page, number } = qs.parse(window.location.search);
    const { form } = this.state;
    const searchParams = {};
    let search = false;
    let pageParam = parseInt(page || 0, 10);

    if (pageParam > 0) {
      searchParams.page = pageParam;
    }
    if (number > 0) {
      search = true;
      form.number.value = number;
      searchParams.number = number;
      searchParams.view = "all";
    } else {
      searchParams.sort = "updated";
      searchParams.view = "others";
    }

    const { data, meta } = await API.blanks.getList(
      { ...searchParams },
      { full: true }
    );
    this.setState({
      loading: false,
      blanks: {
        list: data,
        meta
      },
      form,
      search,
      query: {
        page: pageParam
      },
      buttons: {
        filterDisabled: false
      }
    });
  }

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleSearchSubmit = async e => {
    e.preventDefault();

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form,
      buttons: {
        filterDisabled: result.valid
      }
    });

    // Success
    if (result.valid) {
      const number = this.state.form.number.value;

      // Есть изменения?
      if (number && parseInt(number, 10) > 0) {
        this.setState({
          loading: true
        });

        const queryParams = getQueryParams(qs.parse(window.location.search));
        queryParams.view = "all";
        queryParams.number = parseInt(number, 10);

        this.props.history.push({
          pathname: "/blanks",
          search: `?number=${queryParams.number}`
        });

        const { data, meta } = await API.blanks.getList(queryParams, {
          full: true
        });

        this.setState({
          loading: false,
          blanks: {
            list: data,
            meta
          },
          search: true,
          query: {
            page: 0
          },
          buttons: {
            filterDisabled: false
          }
        });
      }
    }
  };

  handleSearchCancel = async e => {
    e.preventDefault();

    this.setState({
      loading: true,
      buttons: {
        filterDisabled: true
      }
    });

    this.props.history.push({
      pathname: "/blanks",
      search: ``
    });

    const { data, meta } = await API.blanks.getList(
      { sort: "updated", view: "others" },
      { full: true }
    );

    this.setState(prevState => {
      return {
        loading: false,
        query: {
          page: 0
        },
        blanks: {
          list: data,
          meta
        },
        search: false,
        form: {
          ...prevState.form,
          number: {
            ...prevState.form.number,
            value: "",
            isEdited: true,
            isError: false,
            errors: []
          }
        },
        buttons: {
          filterDisabled: false
        }
      };
    });
  };

  onChangedPagination = async page => {
    const { number } = qs.parse(window.location.search);
    const searchParams = { page };
    const queryParams = { page };

    if (number > 0) {
      queryParams.number = number;
      searchParams.number = number;
      searchParams.view = "all";
    } else {
      searchParams.sort = "updated";
      searchParams.view = "others";
    }

    this.props.history.push({
      pathname: "/blanks",
      search: qs.stringify(queryParams, true)
    });

    this.setState({
      loading: true,
      buttons: {
        filterDisabled: true
      }
    });

    const { data, meta } = await API.blanks.getList(
      { ...searchParams },
      {
        full: true
      }
    );

    this.setState({
      loading: false,
      blanks: {
        list: data,
        meta: {
          ...meta
        }
      },
      query: {
        page
      },
      buttons: {
        filterDisabled: false
      }
    });
  };

  getTableColumns = () => {
    return [
      {
        title: "",
        className: "id",
        render: ({ i }) => this.state.blanks.meta.fromRecord + i
      },
      {
        title: "№",
        suffix: "к/о",
        text: "right",
        render: ({ item }) => {
          return (
            <Link to={`/blanks/${item._id}`}>
              {sumFormat(parseInt(item.blank_number, 10))}
            </Link>
          );
        }
      },
      {
        title: "Тип",
        suffix: "к/о",
        render: ({ item }) => {
          let icon = null;

          if (item.blank_type === "type_add") {
            icon = (
              <IconArrowDownLongBold className="icon-td icon-success-active" />
            );
          } else {
            icon = <IconArrowUpLongBold className="icon-td icon-error" />;
          }

          return (
            <VirtualDiv>
              {icon}
              {getStatusBlankString(item.blank_type)}
            </VirtualDiv>
          );
        }
      },
      {
        title: "Филиал",
        render: ({ item }) => {
          return (
            <Link to={`/filials/${item.filial_id._id}`}>
              {item.filial_id.name}
            </Link>
          );
        }
      },
      {
        title: "Сумма",
        text: "right",
        render: ({ item }) => sumFormat(item.sum)
      },
      {
        title: "Основание",
        render: ({ item }) => {
          return (
            <VirtualDiv>
              {item.reason}
              {item.bilet_id ? " " : ""}
              {item.bilet_id &&
              item.bilet_id._id &&
              item.bilet_id.bilet_number ? (
                <Link to={`/bilets/${item.bilet_id._id}`}>
                  №{item.bilet_id.bilet_number}
                </Link>
              ) : (
                ""
              )}
            </VirtualDiv>
          );
        }
      },
      {
        title: "Кому/От кого",
        suffix: "Выдано/Принято",
        render: ({ item }) => {
          const userOrDepositorGiveAdd = getTypeBlank(item);

          if (userOrDepositorGiveAdd.isHaveId) {
            return (
              <Link
                to={`/${userOrDepositorGiveAdd.type}s/${userOrDepositorGiveAdd._id}`}
              >
                {userOrDepositorGiveAdd.fio}
              </Link>
            );
          } else {
            return userOrDepositorGiveAdd.fio;
          }
        }
      },
      {
        title: "Ответсвенный",
        render: ({ item }) => {
          return (
            <Link to={`/users/${item.user_id._id}`}>
              {fioLitleTruncateFromObject(item.user_id)}
            </Link>
          );
        }
      },
      {
        title: "Дата",
        suffix: "создания",
        render: ({ item }) => getDateFormat(item.created_at)
      }
    ];
  };

  render() {
    const { blanks } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage title={this.state.titleHeader} count={blanks.meta.count} />

        <form className="form" onSubmit={this.handleSearchSubmit}>
          <Row>
            <Col padding="no-top-bottom">
              <Input
                placeholder="Поиск по № к/о..."
                type="integer"
                name="number"
                value={this.state.form.number.value}
                errors={this.state.form.number.errors}
                handleChange={this.handleInput}
                size="s"
              />
            </Col>
            <Col padding="no-top-bottom-left">
              <Button
                type="submit"
                theme="dark"
                outline={true}
                size="s"
                disabled={this.state.buttons.filterDisabled}
              >
                Фильтр
              </Button>
              {this.state.search ? (
                <Button
                  type="button"
                  theme="grey"
                  outline={true}
                  onClick={this.handleSearchCancel}
                  size="s"
                  disabled={this.state.buttons.filterDisabled}
                >
                  Сбросить
                </Button>
              ) : null}
            </Col>
          </Row>
        </form>

        <Table
          columns={this.getTableColumns()}
          data={blanks.list}
          loading={this.state.loading}
        />

        <Pagination
          linkPages={"/blanks"}
          linkPagesQuery={false}
          count={blanks.meta.count}
          page={blanks.meta.page || this.state.query.page}
          pages={blanks.meta.pages}
          onClick={this.onChangedPagination}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(BlanksListPage));
